import { actionCreator, stateChangeOnlyActionCreator } from '../../store/actionCreators';
import * as actionType from './actionTypes';

export const loginAction = actionCreator(actionType.LOGIN_ACTIONTYPE);
export const getRecoveryLinkAction = actionCreator(actionType.GET_RECOVERY_LINK_ACTIONTYPE)
export const executeResetPasswordAction = actionCreator(actionType.EXECUTE_RESET_PASSWORD_ACTIONTYPE)

export const resetRecoveryFormAction = stateChangeOnlyActionCreator(actionType.RESET_RECOVERY_FORM_ACTIONTYPE)
